import { client } from "./client";
import interceptors from "./interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSummaryPenjualan(params) {
    return client.get("tunnel/api/pos/dashboard/summary_total_transaction_register", {
        params: params,
    });
}

function getSummaryPenjualanByYear() {
    return client.get("tunnel/api/pos/dashboard/summary_transaction_by_year");
}

function getSummaryPenjualanYearByProduk(val) {
    return client.get("tunnel/api/pos/dashboard/summary_transaction_by_year_by_product", {
        params: val
    });
}

function getSummaryMitraBaruByYear(params) {
    return client.get("tunnel/api/pos/dashboard/summary_register_by_year", {
        params: params,
    });
}

function getMitraBaru(params) {
    return client.get("tunnel/api/pos/dashboard/mitra_baru", {
        params: params,
    });
}

function getSummaryStockProduct() {
    return client.get("tunnel/api/pos/dashboard/stock");
}

function getPurchaseOrder() {
    return client.get("tunnel/api/pos/dashboard/total_po");
}

export default {
    getSummaryPenjualan,
    getSummaryMitraBaruByYear,
    getSummaryPenjualanByYear,
    getMitraBaru,
    getSummaryPenjualanYearByProduk,
    getSummaryStockProduct,
    getPurchaseOrder
};